import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FolderViewComponent } from './folder-view/folder-view.component';
import { JournalComponent } from './journal/journal.component';
import { SpeechToTextComponent } from './voiceclips/components/speech-to-text/speech-to-text.component';

const routes: Routes = [
  {path: '', component: JournalComponent},
  {path: 'October2020', component: FolderViewComponent },
  {path: '25October', component: SpeechToTextComponent}
]

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
